import PropTypes from "prop-types";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { setMessage } from "../../../common/Toast/actions/toastActions";
import type { RootState } from "../../../store";
import { TOAST_ERROR_TYPE } from "../../consts/ToastTypes";
import { PARTICIPANT_STRIPE_HOME_PATH } from "../../consts/participantHomePath";
import { RedirectKeepUTM } from "../RedirectKeepUTM";

const restrictedMessage = "These features are only allowed for premium users";

export const PrivateRoute = ({ children, hasAccess, isDisplayed, ...rest }) => {
  const dispatch = useDispatch();
  const authId = useSelector((state: RootState) => state.auth.login.authId);

  const redirectPath = useCallback(() => {
    if (!authId) {
      return "/";
    }

    if (isDisplayed) {
      dispatch(
        setMessage({ message: restrictedMessage, type: TOAST_ERROR_TYPE })
      );
    }

    return PARTICIPANT_STRIPE_HOME_PATH;
  }, [dispatch, authId, isDisplayed]);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        authId && hasAccess ? (
          children
        ) : (
          <RedirectKeepUTM
            to={{
              pathname: redirectPath(),
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  hasAccess: PropTypes.bool,
  isDisplayed: PropTypes.bool,
};

PrivateRoute.defaultProps = {
  hasAccess: true,
  isDisplayed: true,
};
